import { useEffect } from "react";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { useSmartObject, useNotification } from "@eveworld/contexts";
import { Severity } from "@eveworld/types";
// import { ErrorNotice, ErrorNoticeTypes } from "@eveworld/ui-components";
import { Navigate } from "react-router-dom";
import { ReactComponent as ReapersLogo } from "/src/images/ReapersLogo.svg";

export default function Home() {
  const { smartAssembly, smartCharacter, loading } = useSmartObject();
  const { notify, handleClose } = useNotification();

  useEffect(() => {
    if (loading) {
      notify({ type: Severity.Info, message: "Loading..." });
    } else {
      handleClose();
    }
  }, [loading]);

  // if ((!loading && !smartAssembly) || smartAssembly == null) {
  //   return <ErrorNotice type={ErrorNoticeTypes.SMART_ASSEMBLY} />;
  // }

  if (smartCharacter == undefined || smartCharacter.corpId == "") {
    return <Navigate to="/recruit" replace />;
  }

  return (
    <>
      <div>
        {/* <Typography
          variant="subtitle1"
          gutterBottom
          color="common.brown"
          // sx={{ width: 300, color: brown }}
        >
          Welcome {smartCharacter.name} to Reapers!
        </Typography>
        <div>
          You are currently in Corp Id{" "}
          <span className="font-bold">{smartCharacter.corpId}</span>
        </div> */}
        <div className="mx-auto relative flex flex-col items-center justify-center">
          <div>
            <ReapersLogo width={512} height={512}></ReapersLogo>
          </div>
        </div>
      </div>
      {/* <Button variant="contained">Hello</Button> */}
    </>
  );
}
